// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"ShareButtons_shareContainer__r5Q9T","label":"ShareButtons_label__xyES3","buttons":"ShareButtons_buttons___w8ah","button":"ShareButtons_button__aABi7","copied":"ShareButtons_copied__hefS5"};
module.exports.__checksum = "0277388ff921"
